import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Alert } from "react-bootstrap";

import Layout from "../layout";
import history from "../../history";

class LogoutPage extends Component {
  componentDidMount() {
    if (this.props.auth.isSignedIn) {
      history.push("/welcome");
    }
  }
  render() {
    return (
      <Layout title="Logout">
        <div>
          <Alert variant={"primary"} className="text-center">
            Thank you for using VC PASS!&nbsp;
            <Link to="/" alt="Login">
              Click here to sign in again.
            </Link>
          </Alert>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return { auth: state.auth };
};

export default connect(mapStateToProps)(LogoutPage);
